import { serviceLocator } from '@/utils/providers/serviceLocator'
import { UserRepository } from '../repositories/UserRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'

export async function getUserByIdCase(id: string) {
  const newRepository = serviceLocator.getService<UserRepository>('UserService')
  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getUserById(id),
    key: 'user',
    filterData: JSON.stringify(id)
  })
  if (data.value?.error) return
  return data.value
}
